module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"more":"More"},"pt-BR":{"more":"Mais"}}')
  delete Component.options._Ctor
}
